(function($){
  var playVideo = {
    init: function(){
      if ($('.video').length){
        playVideo.initplayVideo();
      }
    },
    initplayVideo: function(){
      var $video = $('.video__iframe iframe');
      var $videoBtn = $('.video__btn');
      var $videoMask = $('.video__mask');
      $videoMask.on('click', function() {
        $(this).fadeOut(1000);
        if (new URL($video[0].src).hostname != 'player.vimeo.com'){
          $video[0].src += "&autoplay=1";
        }
        else {
          $video[0].src += "?autoplay=1";
        }
      });
    }
  };
  $(document).ready(playVideo.init);
})(jQuery);
